/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumControlLevel = {
	Country : new EnumItem('国控', 1),
	Province: new EnumItem('省控', 2),
	City    : new EnumItem('市控', 3),
	District: new EnumItem('区控', 4),
	Company : new EnumItem('企业', 5),
	...enumMixn
}
export default EnumControlLevel
